import { render, staticRenderFns } from "./EHistoricoFrequenciaTab.vue?vue&type=template&id=83e7038c&scoped=true"
import script from "./EHistoricoFrequenciaTab.vue?vue&type=script&lang=js"
export * from "./EHistoricoFrequenciaTab.vue?vue&type=script&lang=js"
import style0 from "./EHistoricoFrequenciaTab.vue?vue&type=style&index=0&id=83e7038c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e7038c",
  null
  
)

export default component.exports